module.exports = __webpack_public_path__ + "static/img/product-vilocal.d53fe96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product-vilocal.png
// module id = g0Lh
// module chunks = 0